import useGetReceiptDetails from "../Transaction/getReceiptDetails";
import useBluetoothDevice from "../Bluetooth/useBluetoothDevice";
import printerReceipt from "./printerReceipt";
import { useShowMessage } from "../Common/showMessage";

// Ren Bin, please remember to pass the connectDevice and setConnectDevice state into this function
// Or change to localStorage
export default function useConnectToPrinter(connectDevice, setConnectDevice) {
  const showMessage = useShowMessage();
  const { getReceiptDetails } = useGetReceiptDetails();
  const { checkBluetoothSupport, connectToBluetooth, discoverDeviceServices } =
    useBluetoothDevice(connectDevice, setConnectDevice);

  async function connectToPrinter(
    setLoading,
    transactionInfo,
    plates,
    fetchWrapper,
    saveTransaction = null
  ) {
    const handleConnectError = () => {
      setLoading(false);
      setConnectDevice(null);
      return null;
    };

    try {
      let device = null;
      let characteristic = null;

      setLoading(true);
      const receiptDetails = await getReceiptDetails();

      if (receiptDetails.connection_type == "Bluetooth") {
        const isSupported = await checkBluetoothSupport();
        if (!isSupported) return handleConnectError();

        device = await connectToBluetooth(
          receiptDetails.printer_name,
          receiptDetails.service_uuid
        );
        if (!device) return handleConnectError();

        characteristic = await discoverDeviceServices(
          device,
          receiptDetails.service_uuid
        );
        if (!characteristic) return handleConnectError();
      }

      const printResult = await printerReceipt(
        characteristic,
        receiptDetails,
        transactionInfo,
        plates,
        fetchWrapper
      );
      if (printResult.status) {
        if (saveTransaction) {
          saveTransaction();
        }

        showMessage({
          type: "success",
          message: "Print receipt successfully.",
        });
      } else {
        showMessage({ type: "error", message: printResult.message });
      }
    } catch (error) {
      console.error("Printer Connection Error:", error);
    } finally {
      setLoading(false);
    }
  }

  return { connectToPrinter };
}
